import Text from '~components/Text';
import { COMPANYS_SOURCE_VALUE } from '~types/company';
import { formattedMoney } from '~utils/formatted/number';

import * as S from './style';

interface Props {
  companySource: COMPANYS_SOURCE_VALUE;
  corpSalary?: number;
  mlSalary?: number;
}

export default function SalariesByCorp({ corpSalary, mlSalary, companySource }: Props) {
  if (!mlSalary && !corpSalary && companySource !== '기업 제공') {
    return null;
  }

  return (
    <>
      <S.Wrapper>
        {companySource === '기업 제공' && (
          <S.Item>
            <Text typography='bold120_B3'>
              기업 제공 {corpSalary ? `${formattedMoney(corpSalary)}만원` : '정보없음'}
            </Text>
          </S.Item>
        )}

        {mlSalary && (
          <S.Item>
            <Text typography='bold120_B3'>머신러닝 추정 {formattedMoney(mlSalary)}만원</Text>
          </S.Item>
        )}
      </S.Wrapper>
    </>
  );
}
